import React, { useEffect, useState, createContext, useContext } from 'react';
// Create a context for language state
const LanguageContext = createContext<{
  language: 'en' | 'vi';
  toggleLanguage: () => void;
  setLanguage: (lang: 'en' | 'vi') => void;
}>({
  language: 'en',
  toggleLanguage: () => {},
  setLanguage: () => {}
});
// Create a provider component
export const LanguageProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [language, setLanguageState] = useState<'en' | 'vi'>('en');
  // Initialize language from localStorage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferred_language') as 'en' | 'vi' | null;
    if (savedLanguage) {
      setLanguageState(savedLanguage);
    }
  }, []);
  // Update localStorage whenever language changes
  useEffect(() => {
    localStorage.setItem('preferred_language', language);
  }, [language]);
  const toggleLanguage = () => {
    setLanguageState(language === 'en' ? 'vi' : 'en');
  };
  const setLanguage = (lang: 'en' | 'vi') => {
    setLanguageState(lang);
  };
  return <LanguageContext.Provider value={{
    language,
    toggleLanguage,
    setLanguage
  }} data-id="element-1436">
      {children}
    </LanguageContext.Provider>;
};
// Create a custom hook to use the language context
export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;